export const appConfig = {
  /** Where static-snapshot source files live (same-origin, no backend). */
  dataSnapshotBasePath: '/data-snapshots',
  geoBasePath: '/geo',

  /**
   * Candidate base URLs for the real backend (autova-backend, Real Data
   * Stats Layer -- see src/data/adapters/mayBackendAdapter.ts). Tried in
   * order; first one that responds wins. `VITE_MAY_API_BASE_URL` lets a
   * production build point at the real deployed API without a code change
   * (set it in the Cloudflare Pages/build environment for this project).
   * The last entry is a local-dev convenience so `npm run dev` here picks
   * up a locally-running `npm run dev` in backend/ automatically, same
   * reasoning as mayassistant-website/js/*.js's API_CANDIDATES arrays.
   */
  mayApiBaseUrlCandidates: [
    import.meta.env.VITE_MAY_API_BASE_URL as string | undefined,
    // Real backend (Railway service "autova-realtor-va", public domain
    // confirmed 2026-07-29). Update this if a custom domain (e.g.
    // api.may-assistant.com) is ever pointed at this service instead --
    // Railway-assigned *.up.railway.app domains are stable but a custom
    // domain is nicer long-term.
    'https://autova-realtor-va-production.up.railway.app',
    'http://localhost:4000',
  ].filter((v): v is string => Boolean(v)),

  /** Refresh cadence per tier, in milliseconds (see refreshScheduler.ts). */
  refreshIntervalsMs: {
    liveTicker: 5 * 60 * 1000, // 5m: cheap "is anything new" head check
    marketSnapshot: 60 * 60 * 1000, // 1h: re-check snapshot freshness
    geographyCache: 12 * 60 * 60 * 1000, // 12h: boundary files rarely change
    fullRevalidate: 24 * 60 * 60 * 1000, // 24h: force full re-parse + rescore
  },

  defaultGeoLevel: 'county' as const,
  defaultCenter: { lat: 31.0, lon: -99.5 }, // roughly the geographic center of Texas
  defaultZoom: 6,

  texasStateFips: '48',
};
